import "../../../../../../../vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import { cssrAnchorMetaName as et } from "../../../_mixins/common.js";
import { c as we } from "../../../_utils/cssr/index.js";
import { configProviderInjectionKey as tt } from "../../../config-provider/src/context.js";
import { dataTableInjectionKey as at } from "../interface.js";
import { createRowClassName as lt, getColKey as nt, isColumnSorting as ot } from "../utils.js";
import it from "./BodyCheckbox.js";
import rt from "./BodyRadio.js";
import dt from "./Cell.js";
import We from "./ExpandTrigger.js";
import st from "./Header.js";
import ze from "../../../../../../../vooks@0.2.12_vue@3.5.18/node_modules/vooks/es/use-memo.js";
import { formatLength as ct } from "../../../_utils/css/format-length.js";
import { pxfy as G } from "../../../../../../../seemly@0.3.10/node_modules/seemly/es/css/index.js";
import ut from "../../../../../../../vueuc@0.4.64_vue@3.5.18/node_modules/vueuc/es/virtual-list/src/VirtualList.js";
import ft from "../../../_internal/scrollbar/src/Scrollbar.js";
import mt from "../../../../../../../vueuc@0.4.64_vue@3.5.18/node_modules/vueuc/es/resize-observer/src/VResizeObserver.js";
import { warn as Xe } from "../../../_utils/naive/warn.js";
import { repeat as ht } from "../../../../../../../seemly@0.3.10/node_modules/seemly/es/misc/index.js";
import { resolveSlot as yt } from "../../../_utils/vue/resolve-slot.js";
import pt from "../../../empty/src/Empty.js";
import { defineComponent as Je, inject as qe, computed as Ge, watchEffect as vt, onUnmounted as xt, h as o, Fragment as bt } from "../../../../../../../@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
import { ref as Ue } from "../../../../../../../@vue_reactivity@3.5.18/node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js";
function gt(R, C) {
  const a = [];
  function m(v, h) {
    v.forEach((S) => {
      S.children && C.has(S.key) ? (a.push({
        tmNode: S,
        striped: !1,
        key: S.key,
        index: h
      }), m(S.children, h)) : a.push({
        key: S.key,
        tmNode: S,
        striped: !1,
        index: h
      });
    });
  }
  return R.forEach((v) => {
    a.push(v);
    const {
      children: h
    } = v.tmNode;
    h && C.has(v.key) && m(h, v.index);
  }), a;
}
const Rt = Je({
  props: {
    clsPrefix: {
      type: String,
      required: !0
    },
    id: {
      type: String,
      required: !0
    },
    cols: {
      type: Array,
      required: !0
    },
    onMouseenter: Function,
    onMouseleave: Function
  },
  render() {
    const {
      clsPrefix: R,
      id: C,
      cols: a,
      onMouseenter: m,
      onMouseleave: v
    } = this;
    return o("table", {
      style: {
        tableLayout: "fixed"
      },
      class: `${R}-data-table-table`,
      onMouseenter: m,
      onMouseleave: v
    }, o("colgroup", null, a.map((h) => o("col", {
      key: h.key,
      style: h.style
    }))), o("tbody", {
      "data-n-id": C,
      class: `${R}-data-table-tbody`
    }, this.$slots));
  }
}), Bt = Je({
  name: "DataTableBody",
  props: {
    onResize: Function,
    showHeader: Boolean,
    flexHeight: Boolean,
    bodyStyle: Object
  },
  setup(R) {
    const {
      slots: C,
      bodyWidthRef: a,
      mergedExpandedRowKeysRef: m,
      mergedClsPrefixRef: v,
      mergedThemeRef: h,
      scrollXRef: S,
      colsRef: ke,
      paginatedDataRef: H,
      rawPaginatedDataRef: $e,
      fixedColumnLeftMapRef: re,
      fixedColumnRightMapRef: de,
      mergedCurrentPageRef: Ee,
      rowClassNameRef: J,
      leftActiveFixedColKeyRef: se,
      leftActiveFixedChildrenColKeysRef: k,
      rightActiveFixedColKeyRef: Q,
      rightActiveFixedChildrenColKeysRef: $,
      renderExpandRef: Te,
      hoverKeyRef: ce,
      summaryRef: Ke,
      mergedSortStateRef: Le,
      virtualScrollRef: j,
      virtualScrollXRef: Y,
      heightForRowRef: Pe,
      minRowHeightRef: Z,
      componentId: O,
      mergedTableLayoutRef: ue,
      childTriggerColIndexRef: Me,
      indentRef: fe,
      rowPropsRef: me,
      maxHeightRef: he,
      stripedRef: ee,
      loadingRef: ye,
      onLoadRef: pe,
      loadingKeySetRef: V,
      expandableRef: ve,
      stickyExpandedRowsRef: te,
      renderExpandIconRef: Ne,
      summaryPlacementRef: ae,
      treeMateRef: xe,
      scrollbarPropsRef: I,
      setHeaderScrollLeft: le,
      doUpdateExpandedRowKeys: z,
      handleTableBodyScroll: M,
      doCheck: ne,
      doUncheck: N,
      renderCell: be
    } = qe(at), K = qe(tt), _ = Ue(null), B = Ue(null), ge = Ue(null), A = ze(() => H.value.length === 0), W = ze(() => R.showHeader || !A.value), oe = ze(() => R.showHeader || A.value);
    let t = "";
    const i = Ge(() => new Set(m.value));
    function x(e) {
      var l;
      return (l = xe.value.getNode(e)) === null || l === void 0 ? void 0 : l.rawNode;
    }
    function y(e, l, r) {
      const n = x(e.key);
      if (!n) {
        Xe("data-table", `fail to get row data with key ${e.key}`);
        return;
      }
      if (r) {
        const f = H.value.findIndex((s) => s.key === t);
        if (f !== -1) {
          const s = H.value.findIndex((D) => D.key === e.key), c = Math.min(f, s), P = Math.max(f, s), F = [];
          H.value.slice(c, P + 1).forEach((D) => {
            D.disabled || F.push(D.key);
          }), l ? ne(F, !1, n) : N(F, n), t = e.key;
          return;
        }
      }
      l ? ne(e.key, !1, n) : N(e.key, n), t = e.key;
    }
    function ie(e) {
      const l = x(e.key);
      if (!l) {
        Xe("data-table", `fail to get row data with key ${e.key}`);
        return;
      }
      ne(e.key, !0, l);
    }
    function _e() {
      if (!W.value) {
        const {
          value: l
        } = ge;
        return l || null;
      }
      if (j.value)
        return p();
      const {
        value: e
      } = _;
      return e ? e.containerRef : null;
    }
    function Ae(e, l) {
      var r;
      if (V.value.has(e))
        return;
      const {
        value: n
      } = m, f = n.indexOf(e), s = Array.from(n);
      ~f ? (s.splice(f, 1), z(s)) : l && !l.isLeaf && !l.shallowLoaded ? (V.value.add(e), (r = pe.value) === null || r === void 0 || r.call(pe, l.rawNode).then(() => {
        const {
          value: c
        } = m, P = Array.from(c);
        ~P.indexOf(e) || P.push(e), z(P);
      }).finally(() => {
        V.value.delete(e);
      })) : (s.push(e), z(s));
    }
    function w() {
      ce.value = null;
    }
    function p() {
      const {
        value: e
      } = B;
      return (e == null ? void 0 : e.listElRef) || null;
    }
    function Fe() {
      const {
        value: e
      } = B;
      return (e == null ? void 0 : e.itemsElRef) || null;
    }
    function De(e) {
      var l;
      M(e), (l = _.value) === null || l === void 0 || l.sync();
    }
    function L(e) {
      var l;
      const {
        onResize: r
      } = R;
      r && r(e), (l = _.value) === null || l === void 0 || l.sync();
    }
    const b = {
      getScrollContainer: _e,
      scrollTo(e, l) {
        var r, n;
        j.value ? (r = B.value) === null || r === void 0 || r.scrollTo(e, l) : (n = _.value) === null || n === void 0 || n.scrollTo(e, l);
      }
    }, X = we([({
      props: e
    }) => {
      const l = (n) => n === null ? null : we(`[data-n-id="${e.componentId}"] [data-col-key="${n}"]::after`, {
        boxShadow: "var(--n-box-shadow-after)"
      }), r = (n) => n === null ? null : we(`[data-n-id="${e.componentId}"] [data-col-key="${n}"]::before`, {
        boxShadow: "var(--n-box-shadow-before)"
      });
      return we([l(e.leftActiveFixedColKey), r(e.rightActiveFixedColKey), e.leftActiveFixedChildrenColKeys.map((n) => l(n)), e.rightActiveFixedChildrenColKeys.map((n) => r(n))]);
    }]);
    let u = !1;
    return vt(() => {
      const {
        value: e
      } = se, {
        value: l
      } = k, {
        value: r
      } = Q, {
        value: n
      } = $;
      if (!u && e === null && r === null)
        return;
      const f = {
        leftActiveFixedColKey: e,
        leftActiveFixedChildrenColKeys: l,
        rightActiveFixedColKey: r,
        rightActiveFixedChildrenColKeys: n,
        componentId: O
      };
      X.mount({
        id: `n-${O}`,
        force: !0,
        props: f,
        anchorMetaName: et,
        parent: K == null ? void 0 : K.styleMountTarget
      }), u = !0;
    }), xt(() => {
      X.unmount({
        id: `n-${O}`,
        parent: K == null ? void 0 : K.styleMountTarget
      });
    }), Object.assign({
      bodyWidth: a,
      summaryPlacement: ae,
      dataTableSlots: C,
      componentId: O,
      scrollbarInstRef: _,
      virtualListRef: B,
      emptyElRef: ge,
      summary: Ke,
      mergedClsPrefix: v,
      mergedTheme: h,
      scrollX: S,
      cols: ke,
      loading: ye,
      bodyShowHeaderOnly: oe,
      shouldDisplaySomeTablePart: W,
      empty: A,
      paginatedDataAndInfo: Ge(() => {
        const {
          value: e
        } = ee;
        let l = !1;
        return {
          data: H.value.map(e ? (n, f) => (n.isLeaf || (l = !0), {
            tmNode: n,
            key: n.key,
            striped: f % 2 === 1,
            index: f
          }) : (n, f) => (n.isLeaf || (l = !0), {
            tmNode: n,
            key: n.key,
            striped: !1,
            index: f
          })),
          hasChildren: l
        };
      }),
      rawPaginatedData: $e,
      fixedColumnLeftMap: re,
      fixedColumnRightMap: de,
      currentPage: Ee,
      rowClassName: J,
      renderExpand: Te,
      mergedExpandedRowKeySet: i,
      hoverKey: ce,
      mergedSortState: Le,
      virtualScroll: j,
      virtualScrollX: Y,
      heightForRow: Pe,
      minRowHeight: Z,
      mergedTableLayout: ue,
      childTriggerColIndex: Me,
      indent: fe,
      rowProps: me,
      maxHeight: he,
      loadingKeySet: V,
      expandable: ve,
      stickyExpandedRows: te,
      renderExpandIcon: Ne,
      scrollbarProps: I,
      setHeaderScrollLeft: le,
      handleVirtualListScroll: De,
      handleVirtualListResize: L,
      handleMouseleaveTable: w,
      virtualListContainer: p,
      virtualListContent: Fe,
      handleTableBodyScroll: M,
      handleCheckboxUpdateChecked: y,
      handleRadioUpdateChecked: ie,
      handleUpdateExpanded: Ae,
      renderCell: be
    }, b);
  },
  render() {
    const {
      mergedTheme: R,
      scrollX: C,
      mergedClsPrefix: a,
      virtualScroll: m,
      maxHeight: v,
      mergedTableLayout: h,
      flexHeight: S,
      loadingKeySet: ke,
      onResize: H,
      setHeaderScrollLeft: $e
    } = this, re = C !== void 0 || v !== void 0 || S, de = !re && h === "auto", Ee = C !== void 0 || de, J = {
      minWidth: ct(C) || "100%"
    };
    C && (J.width = "100%");
    const se = o(ft, Object.assign({}, this.scrollbarProps, {
      ref: "scrollbarInstRef",
      scrollable: re || de,
      class: `${a}-data-table-base-table-body`,
      style: this.empty ? void 0 : this.bodyStyle,
      theme: R.peers.Scrollbar,
      themeOverrides: R.peerOverrides.Scrollbar,
      contentStyle: J,
      container: m ? this.virtualListContainer : void 0,
      content: m ? this.virtualListContent : void 0,
      horizontalRailStyle: {
        zIndex: 3
      },
      verticalRailStyle: {
        zIndex: 3
      },
      xScrollable: Ee,
      onScroll: m ? void 0 : this.handleTableBodyScroll,
      internalOnUpdateScrollLeft: $e,
      onResize: H
    }), {
      default: () => {
        const k = {}, Q = {}, {
          cols: $,
          paginatedDataAndInfo: Te,
          mergedTheme: ce,
          fixedColumnLeftMap: Ke,
          fixedColumnRightMap: Le,
          currentPage: j,
          rowClassName: Y,
          mergedSortState: Pe,
          mergedExpandedRowKeySet: Z,
          stickyExpandedRows: O,
          componentId: ue,
          childTriggerColIndex: Me,
          expandable: fe,
          rowProps: me,
          handleMouseleaveTable: he,
          renderExpand: ee,
          summary: ye,
          handleCheckboxUpdateChecked: pe,
          handleRadioUpdateChecked: V,
          handleUpdateExpanded: ve,
          heightForRow: te,
          minRowHeight: Ne,
          virtualScrollX: ae
        } = this, {
          length: xe
        } = $;
        let I;
        const {
          data: le,
          hasChildren: z
        } = Te, M = z ? gt(le, Z) : le;
        if (ye) {
          const t = ye(this.rawPaginatedData);
          if (Array.isArray(t)) {
            const i = t.map((x, y) => ({
              isSummaryRow: !0,
              key: `__n_summary__${y}`,
              tmNode: {
                rawNode: x,
                disabled: !0
              },
              index: -1
            }));
            I = this.summaryPlacement === "top" ? [...i, ...M] : [...M, ...i];
          } else {
            const i = {
              isSummaryRow: !0,
              key: "__n_summary__",
              tmNode: {
                rawNode: t,
                disabled: !0
              },
              index: -1
            };
            I = this.summaryPlacement === "top" ? [i, ...M] : [...M, i];
          }
        } else
          I = M;
        const ne = z ? {
          width: G(this.indent)
        } : void 0, N = [];
        I.forEach((t) => {
          ee && Z.has(t.key) && (!fe || fe(t.tmNode.rawNode)) ? N.push(t, {
            isExpandedRow: !0,
            key: `${t.key}-expand`,
            // solve key repeat of the expanded row
            tmNode: t.tmNode,
            index: t.index
          }) : N.push(t);
        });
        const {
          length: be
        } = N, K = {};
        le.forEach(({
          tmNode: t
        }, i) => {
          K[i] = t.key;
        });
        const _ = O ? this.bodyWidth : null, B = _ === null ? void 0 : `${_}px`, ge = this.virtualScrollX ? "div" : "td";
        let A = 0, W = 0;
        ae && $.forEach((t) => {
          t.column.fixed === "left" ? A++ : t.column.fixed === "right" && W++;
        });
        const oe = ({
          // Normal
          rowInfo: t,
          displayedRowIndex: i,
          isVirtual: x,
          // Virtual X
          isVirtualX: y,
          startColIndex: ie,
          endColIndex: _e,
          getLeft: Ae
        }) => {
          const {
            index: w
          } = t;
          if ("isExpandedRow" in t) {
            const {
              tmNode: {
                key: s,
                rawNode: c
              }
            } = t;
            return o("tr", {
              class: `${a}-data-table-tr ${a}-data-table-tr--expanded`,
              key: `${s}__expand`
            }, o("td", {
              class: [`${a}-data-table-td`, `${a}-data-table-td--last-col`, i + 1 === be && `${a}-data-table-td--last-row`],
              colspan: xe
            }, O ? o("div", {
              class: `${a}-data-table-expand`,
              style: {
                width: B
              }
            }, ee(c, w)) : ee(c, w)));
          }
          const p = "isSummaryRow" in t, Fe = !p && t.striped, {
            tmNode: De,
            key: L
          } = t, {
            rawNode: b
          } = De, X = Z.has(L), u = me ? me(b, w) : void 0, e = typeof Y == "string" ? Y : lt(b, w, Y), l = y ? $.filter((s, c) => !!(ie <= c && c <= _e || s.column.fixed)) : $, r = y ? G((te == null ? void 0 : te(b, w)) || Ne) : void 0, n = l.map((s) => {
            var c, P, F, D, He;
            const E = s.index;
            if (i in k) {
              const g = k[i], T = g.indexOf(E);
              if (~T)
                return g.splice(T, 1), null;
            }
            const {
              column: d
            } = s, q = nt(s), {
              rowSpan: je,
              colSpan: Ve
            } = d, Re = p ? ((c = t.tmNode.rawNode[q]) === null || c === void 0 ? void 0 : c.colSpan) || 1 : Ve ? Ve(b, w) : 1, Ce = p ? ((P = t.tmNode.rawNode[q]) === null || P === void 0 ? void 0 : P.rowSpan) || 1 : je ? je(b, w) : 1, Qe = E + Re === xe, Ye = i + Ce === be, Se = Ce > 1;
            if (Se && (Q[i] = {
              [E]: []
            }), Re > 1 || Se)
              for (let g = i; g < i + Ce; ++g) {
                Se && Q[i][E].push(K[g]);
                for (let T = E; T < E + Re; ++T)
                  g === i && T === E || (g in k ? k[g].push(T) : k[g] = [T]);
              }
            const Ie = Se ? this.hoverKey : null, {
              cellProps: Oe
            } = d, U = Oe == null ? void 0 : Oe(b, w), Be = {
              "--indent-offset": ""
            }, Ze = d.fixed ? "td" : ge;
            return o(Ze, Object.assign({}, U, {
              key: q,
              style: [{
                textAlign: d.align || void 0,
                width: G(d.width)
              }, y && {
                height: r
              }, y && !d.fixed ? {
                position: "absolute",
                left: G(Ae(E)),
                top: 0,
                bottom: 0
              } : {
                left: G((F = Ke[q]) === null || F === void 0 ? void 0 : F.start),
                right: G((D = Le[q]) === null || D === void 0 ? void 0 : D.start)
              }, Be, (U == null ? void 0 : U.style) || ""],
              colspan: Re,
              rowspan: x ? void 0 : Ce,
              "data-col-key": q,
              class: [`${a}-data-table-td`, d.className, U == null ? void 0 : U.class, p && `${a}-data-table-td--summary`, Ie !== null && Q[i][E].includes(Ie) && `${a}-data-table-td--hover`, ot(d, Pe) && `${a}-data-table-td--sorting`, d.fixed && `${a}-data-table-td--fixed-${d.fixed}`, d.align && `${a}-data-table-td--${d.align}-align`, d.type === "selection" && `${a}-data-table-td--selection`, d.type === "expand" && `${a}-data-table-td--expand`, Qe && `${a}-data-table-td--last-col`, Ye && `${a}-data-table-td--last-row`]
            }), z && E === Me ? [ht(Be["--indent-offset"] = p ? 0 : t.tmNode.level, o("div", {
              class: `${a}-data-table-indent`,
              style: ne
            })), p || t.tmNode.isLeaf ? o("div", {
              class: `${a}-data-table-expand-placeholder`
            }) : o(We, {
              class: `${a}-data-table-expand-trigger`,
              clsPrefix: a,
              expanded: X,
              rowData: b,
              renderExpandIcon: this.renderExpandIcon,
              loading: ke.has(t.key),
              onClick: () => {
                ve(L, t.tmNode);
              }
            })] : null, d.type === "selection" ? p ? null : d.multiple === !1 ? o(rt, {
              key: j,
              rowKey: L,
              disabled: t.tmNode.disabled,
              onUpdateChecked: () => {
                V(t.tmNode);
              }
            }) : o(it, {
              key: j,
              rowKey: L,
              disabled: t.tmNode.disabled,
              onUpdateChecked: (g, T) => {
                pe(t.tmNode, g, T.shiftKey);
              }
            }) : d.type === "expand" ? p ? null : !d.expandable || !((He = d.expandable) === null || He === void 0) && He.call(d, b) ? o(We, {
              clsPrefix: a,
              rowData: b,
              expanded: X,
              renderExpandIcon: this.renderExpandIcon,
              onClick: () => {
                ve(L, null);
              }
            }) : null : o(dt, {
              clsPrefix: a,
              index: w,
              row: b,
              column: d,
              isSummary: p,
              mergedTheme: ce,
              renderCell: this.renderCell
            }));
          });
          return y && A && W && n.splice(A, 0, o("td", {
            colspan: $.length - A - W,
            style: {
              pointerEvents: "none",
              visibility: "hidden",
              height: 0
            }
          })), o("tr", Object.assign({}, u, {
            onMouseenter: (s) => {
              var c;
              this.hoverKey = L, (c = u == null ? void 0 : u.onMouseenter) === null || c === void 0 || c.call(u, s);
            },
            key: L,
            class: [`${a}-data-table-tr`, p && `${a}-data-table-tr--summary`, Fe && `${a}-data-table-tr--striped`, X && `${a}-data-table-tr--expanded`, e, u == null ? void 0 : u.class],
            style: [u == null ? void 0 : u.style, y && {
              height: r
            }]
          }), n);
        };
        return m ? o(ut, {
          ref: "virtualListRef",
          items: N,
          itemSize: this.minRowHeight,
          visibleItemsTag: Rt,
          visibleItemsProps: {
            clsPrefix: a,
            id: ue,
            cols: $,
            onMouseleave: he
          },
          showScrollbar: !1,
          onResize: this.handleVirtualListResize,
          onScroll: this.handleVirtualListScroll,
          itemsStyle: J,
          itemResizable: !ae,
          columns: $,
          renderItemWithCols: ae ? ({
            itemIndex: t,
            item: i,
            startColIndex: x,
            endColIndex: y,
            getLeft: ie
          }) => oe({
            displayedRowIndex: t,
            isVirtual: !0,
            isVirtualX: !0,
            rowInfo: i,
            startColIndex: x,
            endColIndex: y,
            getLeft: ie
          }) : void 0
        }, {
          default: ({
            item: t,
            index: i,
            renderedItemWithCols: x
          }) => x || oe({
            rowInfo: t,
            displayedRowIndex: i,
            isVirtual: !0,
            isVirtualX: !1,
            startColIndex: 0,
            endColIndex: 0,
            getLeft(y) {
              return 0;
            }
          })
        }) : o("table", {
          class: `${a}-data-table-table`,
          onMouseleave: he,
          style: {
            tableLayout: this.mergedTableLayout
          }
        }, o("colgroup", null, $.map((t) => o("col", {
          key: t.key,
          style: t.style
        }))), this.showHeader ? o(st, {
          discrete: !1
        }) : null, this.empty ? null : o("tbody", {
          "data-n-id": ue,
          class: `${a}-data-table-tbody`
        }, N.map((t, i) => oe({
          rowInfo: t,
          displayedRowIndex: i,
          isVirtual: !1,
          isVirtualX: !1,
          startColIndex: -1,
          endColIndex: -1,
          getLeft(x) {
            return -1;
          }
        }))));
      }
    });
    if (this.empty) {
      const k = () => o("div", {
        class: [`${a}-data-table-empty`, this.loading && `${a}-data-table-empty--hide`],
        style: this.bodyStyle,
        ref: "emptyElRef"
      }, yt(this.dataTableSlots.empty, () => [o(pt, {
        theme: this.mergedTheme.peers.Empty,
        themeOverrides: this.mergedTheme.peerOverrides.Empty
      })]));
      return this.shouldDisplaySomeTablePart ? o(bt, null, se, k()) : o(mt, {
        onResize: this.onResize
      }, {
        default: k
      });
    }
    return se;
  }
});
export {
  Bt as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/data-table/src/TableParts/Body.js
// module id = 1608
// module chunks = 41